<template>
  <div>
    <div class="text-center mb-3">
      <img :src="`${app.logo}?tr=h-125`" class="logo" />
    </div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-3">
        <strong> {{ $t('authForm.signInDesc') }} </strong>
      </div>
      <div class="mb-4">
      </div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: $t('authForm.requiredEmail') },
                  { type: 'email', message: $t('authForm.formatEmail')}
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            placeholder="Password"
            type="password"
            v-decorator="['password', { rules: [{ required: true, message: $t('authForm.requiredPassword') }]}]"
          />
        </a-form-item>
        <a-button
          type="primary"
          htmlType="submit"
          size="large"
          class="text-center w-100"
          :loading="loading"
        >
          <strong> {{ $t('authForm.signIn') }} </strong>
        </a-button>
      </a-form>
      <router-link to="/auth/forgot-password" class="kit__utils__link font-size-16"> {{ $t('authForm.forgotPassword') }} </router-link>
    </div>
    <div class="text-center pt-2 mb-auto">
      <span class="mr-2"> {{ $t('authForm.dontHaveAccount') }} </span>
      <router-link to="/auth/register" class="kit__utils__link font-size-16"> {{ $t('authForm.register') }} </router-link>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'CuiLogin',
  computed: {
    ...mapState(['settings', 'app']),
    ...mapGetters({ loginStatusCode: 'user/loginStatusCode' }),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()

      this.form.validateFields((err, values) => {
        if (!err) {
          this.$store.dispatch('user/LOGIN', values)
            .then(({ success, message }) => {
              if (success) {
                this.$router.push('/dashboard').catch(err => console.log({ err }))
              } else {
                this.$notification.error({
                  message: this.$t('authForm.loginFailed'),
                  description: message,
                })
              }
            })
        }
      })
    },
  },
  watch: {
  },
}
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
<style lang="scss" scoped>
.logo {
  max-height: 75px;
  max-width: 200px;
}
</style>
